import IoTIcon from '@/assets/images/IoT-ops.png';
import IoTIconSelected from '@/assets/images/iot-ops-selected.png';

import dataIcon from '@/assets/images/data-ops.png';
import dataIconSelected from '@/assets/images/data-ops-selected.png';
import aiIcon from '@/assets/images/ai-ops.png';
import aiIconSelected from '@/assets/images/ai-ops-selected.png';
import recommendIcon from '@/assets/images/recommend-ops.png';
import recommendIconSelected from '@/assets/images/recommend-ops-selected.png';
import marktingIcon from '@/assets/images/markting-ops.png';
import marktingIconSelected from '@/assets/images/markting-ops-selected.png';

import photo from '@/assets/images/photo.png';

import logout from '@/assets/images/log-out-outline.png';

import hamisLogo from '@/assets/images/hamisLogo.png';

export const photos = {
  Ido: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/11.png',
  Poisson: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/22.png',
  Ender: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/33.png',
  Alex: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/44.png',
  JJLin: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/55.png',
  Woodie: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/66.png',
  Zhong: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/77.png',
};

export const companyEvents = {
  数字文明大会: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E6%95%B0%E5%AD%97%E6%96%87%E6%98%8E%E5%A4%A7%E4%BC%9A.png',
  国际高新技术成果交流会: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E5%9B%BD%E9%99%85%E9%AB%98%E6%96%B0%E6%8A%80%E6%9C%AF%E6%88%90%E6%9E%9C%E4%BA%A4%E6%B5%81%E4%BC%9A.png',
  Zeus: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/Zeus.png',
  微看云: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E5%BE%AE%E7%9C%8B%E4%BA%91.png',
  公司成立: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E5%85%AC%E5%8F%B8%E6%88%90%E7%AB%8B.png',
  重庆城市安全大脑: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E9%87%8D%E5%BA%86%E5%9F%8E%E5%B8%82%E5%AE%89%E5%85%A8%E5%A4%A7%E8%84%91.png',
  链上海南: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/%E9%93%BE%E4%B8%8A%E6%B5%B7%E5%8D%97.jpg',
  韩正视察: 'https://alpha-bucket1.oss-cn-hangzhou.aliyuncs.com/%E9%97%A8%E6%88%B7%E9%A1%B9%E7%9B%AE/%E7%85%A7%E7%89%87/IMG_9941.JPG',
}

export default {
  iotOps: {
    icon: IoTIcon,
    selected: IoTIconSelected,
  },
  dataOps: {
    icon: dataIcon,
    selected: dataIconSelected,
  },
  aiOps: {
    icon: aiIcon,
    selected: aiIconSelected,
  },
  recommendOps: {
    icon: recommendIcon,
    selected: recommendIconSelected,
  },
  marktingOps: {
    icon: marktingIcon,
    selected: marktingIconSelected,
  },
  
  photo,
  
  hamisLogo,
  
  logout,
  
  opsCardBackground: {
    Pallas: '/images/AI 中台.jpg',
    Tauras: '/images/交易中台.jpg',
    Ceres: '/images/内容中台.jpg',
    Astrae: '/images/决策分析平台.jpg',
    Saturn: '/images/数据中台.jpg',
    Vesta: '/images/服务开放平台.jpg',
    Merak: '/images/数据可视化平台.jpg',
    Juno: '/images/营销平台.jpg',
    Zeus: '/images/计算中台.jpg',
    Mars: '/images/连接中台.jpg',
  },
  photos,
  companyEvents,
};
